'use strict';
var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('document', 'documentElement');



//////////////////
// WEBPACK FOOTER
// ./~/react-fileupload-progress/~/core-js/internals/html.js
// module id = 1397
// module chunks = 0